<template>
	<IconButton
		v-bind="$attrs"
		class=""
		:class="[]"
		:size="size"
		:border="border"
		:border-color="borderColor"
		:background-color="backgroundColor"
		:text-color="textColor"
		:shadow="shadow"
		:rounded="rounded"
		:font-size="fontSize"
		:icon-on-left="iconOnLeft"
		icon-class="w-3 h-3 text-gray-700"
		:min-width="`min-w-none`"
		@click="onClick"
	>
		<slot>Remove Me</slot>
	</IconButton>
</template>

<script setup>
import IconButton from '@/components/buttons/IconButton.vue'

const props = defineProps({
	iconOnLeft: {
		type: Boolean,
		default: false,
		required: false,
	},
	size: {
		type: Number,
		default: 3,
		required: false,
	},
	backgroundColor: {
		type: String,
		default: 'bg-gray-140',
		required: false,
	},
	textColor: {
		type: String,
		default: 'text-gray-650',
		required: false,
	},
	fontSize: {
		type: String,
		default: 'text-sm',
		required: false,
	},
	border: {
		type: String,
		default: '',
		required: false,
	},
	borderColor: {
		type: String,
		default: '',
		required: false,
	},
	shadow: {
		type: String,
		default: '',
		required: false,
	},
	rounded: {
		type: String,
		default: 'rounded-full',
		required: false,
	},
})

const emit = defineEmits(['click'])

const onClick = () => {
	emit('click')
}
</script>
